import { Box, Card, styled } from '@mui/material';
import { ConnectCandidateMatchArchiveCardDataTestIds } from 'data-testids/CandidatePortalDataTestIds';
import { CandidateMatchArchiveCardInterface } from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchDashboard/utils/types';
import { PrincipalMessage } from '../PrincipalMessage/PrincipalMessage';
import { StyledTextButton } from 'sharedComponents/Buttons/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';
import { MatchCardDivider } from '../MatchCard/CandidateMatchCard';
import { CandidateMatchArchiveCardTitle } from './CandidateMatchArchiveCardTitle';
import { CandidateMatchArchiveCardHeader } from './CandidateMatchArchiveCardHeader';

export const CandidateMatchArchiveCard: React.FC<CandidateMatchArchiveCardInterface> = ({
  archivedMatch,
}) => {
  const principal = archivedMatch?.principal;
  const principalMessage = archivedMatch?.principal_kickoff_message;
  const { connectContextActions } = useConnectContext();

  return (
    <MatchArchiveCardContainer data-testid={ConnectCandidateMatchArchiveCardDataTestIds.MATCH_CARD}>
      <CandidateMatchArchiveCardTitle archivedMatch={archivedMatch} />
      <CandidateMatchArchiveCardHeader archivedMatch={archivedMatch} />
      <MatchCardDivider data-testid={ConnectCandidateMatchArchiveCardDataTestIds.DIVIDER} />
      <ArchivedMatchCardPrincipalSection
        data-testid={ConnectCandidateMatchArchiveCardDataTestIds.PRINCIPAL_SECTION}
      >
        <PrincipalMessage
          principal={principal}
          principalMessage={principalMessage}
          isMatchArchive={true}
        />
      </ArchivedMatchCardPrincipalSection>
      <ShowMoreButtonContainer>
        <StyledTextButton
          data-testid={ConnectCandidateMatchArchiveCardDataTestIds.VIEW_SCHOOL_DETAILS_BUTTON}
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            connectContextActions.setSelectedSchool(archivedMatch?.school);
            connectContextActions.setIsMoreInfoSliderOpen(true);
          }}
        >
          View school details
        </StyledTextButton>
      </ShowMoreButtonContainer>
    </MatchArchiveCardContainer>
  );
};

const MatchArchiveCardContainer = styled(Card)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  padding: theme.spacing(7, 4, 2, 4),
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${theme.palette.border.main}`,
  background: theme.palette.white.main,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(3),
    padding: theme.spacing(7, 2, 2, 2),
  },
}));

const ArchivedMatchCardPrincipalSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(2),
}));

const ShowMoreButtonContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
}));
